import React from 'react'

import { ReactComponent as VectorIcon } from '../../../assets/icons/vector.svg'

// shape
import { ReactComponent as TriangleSmallIcon } from '../../../assets/icons/shape-triangle-small.svg'
import { ReactComponent as TriangleMediumIcon } from '../../../assets/icons/shape-triangle-medium.svg'

import { ReactComponent as CircleSmallIcon } from '../../../assets/icons/shape-circle-small.svg'
import { ReactComponent as CircleMediumIcon } from '../../../assets/icons/shape-circle-medium.svg'

import { ReactComponent as SquareSmallIcon } from '../../../assets/icons/shape-square-small.svg'
import { ReactComponent as SquareMediumIcon } from '../../../assets/icons/shape-square-medium.svg'

import { ReactComponent as LineSmallIcon } from '../../../assets/icons/shape-line-small.svg'
import { ReactComponent as LineMediumIcon } from '../../../assets/icons/shape-line-medium.svg'

import { ReactComponent as PaintFillSmallIcon } from '../../../assets/icons/paint-fill-small.svg'
import { ReactComponent as PaintFillMediumIcon } from '../../../assets/icons/paint-fill-medium.svg'

// thickness
import { ReactComponent as ThicknessSmallSmallIcon } from '../../../assets/icons/thickness-small-small.svg'
import { ReactComponent as ThicknessSmallMediumIcon } from '../../../assets/icons/thickness-small-medium.svg'

import { ReactComponent as ThicknessMediumSmallIcon } from '../../../assets/icons/thickness-medium-small.svg'
import { ReactComponent as ThicknessMediumMediumIcon } from '../../../assets/icons/thickness-medium-medium.svg'

import { ReactComponent as ThicknessLargeSmallIcon } from '../../../assets/icons/thickness-large-small.svg'
import { ReactComponent as ThicknessLargeMediumIcon } from '../../../assets/icons/thickness-large-medium.svg'

import { ReactComponent as ThicknessXLargeSmallIcon } from '../../../assets/icons/thickness-xLarge-small.svg'
import { ReactComponent as ThicknessXLargeMediumIcon } from '../../../assets/icons/thickness-xLarge-medium.svg'

const shapeList = [
  {
    shapeId: 'triangle',
    smallIcon: () => <TriangleSmallIcon />,
    mediumIcon: () => <TriangleMediumIcon />,
  },
  {
    shapeId: 'square',
    smallIcon: () => <SquareSmallIcon />,
    mediumIcon: () => <SquareMediumIcon />,
  },
  {
    shapeId: 'circle',
    smallIcon: () => <CircleSmallIcon />,
    mediumIcon: () => <CircleMediumIcon />,
  },
  { shapeId: 'line', smallIcon: () => <LineSmallIcon />, mediumIcon: () => <LineMediumIcon /> },
]

const colorList1 = [
  { colorId: 'red', color: '#FF4242' },
  { colorId: 'orange', color: '#FF946E' },
  { colorId: 'yellow', color: '#FFC06E' },
  { colorId: 'green', color: '#13BD7E' },
  { colorId: 'light-blue', color: '#3DC2FF' },
]

const colorList2 = [
  { colorId: 'violet', color: '#6541F2' },
  { colorId: 'pink', color: '#FF94ED' },
  { colorId: 'black', color: '#000000' },
  { colorId: 'white', color: '#FFFFFF' },
]

export default function StylePanel({
  selectedTool,
  colorVal,
  setColorVal,
  thicknessVal,
  setThicknessVal,
  selectedShape,
  setSelectedShape,
  isShapeFilled,
  setIsShapeFilled,
}) {
  const thicknessList = [
    {
      thicknessId: 'small',
      thickness: selectedTool === 'pen-highlight' ? 16 : 2,
      roundSize: '10px',
      smallIcon: () => <ThicknessSmallSmallIcon />,
      mediumIcon: () => <ThicknessSmallMediumIcon />,
    },
    {
      thicknessId: 'medium',
      thickness: selectedTool === 'pen-highlight' ? 30 : 4,
      roundSize: '18px',
      smallIcon: () => <ThicknessMediumSmallIcon />,
      mediumIcon: () => <ThicknessMediumMediumIcon />,
    },
    {
      thicknessId: 'large',
      thickness: selectedTool === 'pen-highlight' ? 50 : 8,
      roundSize: '28px',
      smallIcon: () => <ThicknessLargeSmallIcon />,
      mediumIcon: () => <ThicknessLargeMediumIcon />,
    },
    {
      thicknessId: 'xLarge',
      thickness: selectedTool === 'pen-highlight' ? 70 : 16,
      roundSize: '35px',
      smallIcon: () => <ThicknessXLargeSmallIcon />,
      mediumIcon: () => <ThicknessXLargeMediumIcon />,
    },
  ]

  const onChangeColor = (changeColor) => {
    colorVal[selectedTool] = changeColor
    setColorVal({ ...colorVal })
  }
  const onChangeThickness = (changeThickness) => {
    thicknessVal[selectedTool] = changeThickness
    setThicknessVal({ ...thicknessVal })
  }
  const onChangeShape = (changeShape) => {
    setSelectedShape(changeShape)
  }
  const onChangeShapeFilled = () => {
    setIsShapeFilled((prev) => !prev)
  }

  return (
    <div className='sg-absolute sg-flex sg-justify-center sg-items-center sg-z-[99999]'>
      <div className='sg-mr-[3px] xl:sg-mr-[-1px] sg-w-[9px] sg-h-[16px] xl:sg-w-[13px] xl:sg-h-[24px] sg-z-[999999]'>
        <VectorIcon />
      </div>
      {/* will-change-transform: GPU 레이어 생성 예고, "브라우저가 "미리 최적화 준비" */}
      <div className='sg-flex sg-flex-col sg-rounded-[8px] md:sg-rounded-[10px] sg-items-center sg-justify-center sg-bg-sk-white sg-border sg-border-sk-border-default sg-drop-shadow-styleBox sg-will-change-transform'>
        {/* [shape] */}
        <div
          className={`sg-w-full sg-flex sg-gap-16 md:sg-gap-14 xl:sg-gap-20 sg-px-16 sg-justify-center sg-py-8 md:sg-py-12 xl:sg-py-14 sg-border-b sg-border-sk-border-default ${
            selectedTool === 'shape' ? 'sg-block' : 'sg-hidden'
          }`}
        >
          {shapeList.map((shapeItem) => (
            <button
              key={shapeItem.shapeId}
              id={shapeItem.shapeId}
              className={`sg-w-20 sg-h-20 md:sg-w-32 md:sg-h-32 xl:sg-w-40 xl:sg-h-40 sg-flex sg-items-center sg-justify-center sg-rounded-[4px] md:sg-rounded-[6px] ${
                selectedShape === shapeItem.shapeId
                  ? 'sg-bg-sk-background-alternative sg-text-sk-label-info sg-fill-sk-label-info'
                  : 'sg-hover:bg-sk-background-normal-alternative sg-text-sk-label-info sg-fill-sk-white'
              }`}
              onClick={() => onChangeShape(shapeItem.shapeId)}
            >
              <i className='sg-block md:sg-hidden'>{shapeItem.smallIcon()}</i>
              <i className='sg-hidden md:sg-block'>{shapeItem.mediumIcon()}</i>
            </button>
          ))}
        </div>

        {/* [colorVal] */}
        <div className='sg-flex sg-flex-col sg-gap-6 sg-px-16 sg-py-12 sg-border-b md:sg-gap-4 xl:sg-py-14 sg-border-sk-border-default'>
          {/* colorList1 */}
          <div className='sg-flex sg-justify-center sg-w-full sg-gap-6 md:sg-gap-4'>
            {colorList1.map((colorItem) => (
              <button
                key={colorItem.colorId}
                id={colorItem.colorId}
                className={`sg-w-20 sg-h-20 md:sg-w-32 md:sg-h-32 xl:sg-w-40 xl:sg-h-40 sg-flex sg-justify-center sg-items-center sg-rounded-[4px] md:sg-rounded-[6px] ${
                  colorVal[selectedTool] === colorItem.color
                    ? 'sg-border sg-border-sk-border-default sg-bg-sk-background-normal-alternative'
                    : 'sg-hover:bg-sk-background-normal-alternative'
                }`}
                onClick={() => onChangeColor(colorItem.color)}
              >
                <div
                  className={
                    'sg-w-14 sg-h-14 md:sg-w-20 md:sg-h-20 sg-rounded-full sg-hover:bg-sk-background-normal-alternative'
                  }
                  style={{ backgroundColor: colorItem.color }}
                />
              </button>
            ))}
          </div>
          {/* colorList2 */}
          <div className='sg-flex sg-justify-center sg-w-full sg-gap-6'>
            {colorList2.map((colorItem) => (
              <button
                key={colorItem.colorId}
                id={colorItem.colorId}
                className={`sg-w-20 sg-h-20 md:sg-w-32 md:sg-h-32 xl:sg-w-40 xl:sg-h-40 sg-flex sg-justify-center sg-items-center sg-rounded-[4px] md:sg-rounded-[6px] ${
                  colorVal[selectedTool] === colorItem.color
                    ? 'sg-border sg-border-sk-border-default sg-bg-sk-background-normal-alternative'
                    : 'sg-hover:bg-sk-background-normal-alternative'
                }`}
                onClick={() => onChangeColor(colorItem.color)}
              >
                <div
                  className={`sg-w-14 sg-h-14 md:sg-w-20 md:sg-h-20 sg-rounded-full ${
                    colorItem.colorId === 'white'
                      ? 'sg-border sg-border-sk-border-default'
                      : 'sg-hover:bg-sk-background-normal-alternative'
                  }`}
                  style={{ backgroundColor: colorItem.color }}
                />
              </button>
            ))}
          </div>
        </div>

        <div className='sg-flex sg-w-full sg-divide-x'>
          {/* [thicknessVal] */}
          <div
            className={`sg-grid sg-w-full sg-grid-cols-4 sg-justify-items-center ${
              selectedTool === 'shape'
                ? 'sg-px-[11px] sg-py-8 md:sg-px-10 md:sg-py-12'
                : 'sg-px-16 sg-py-8 md:sg-px-20 md:sg-py-12'
            }`}
          >
            {thicknessList.map((thicknessItem) => (
              <button
                key={thicknessItem.thicknessId}
                id={thicknessItem.thicknessId}
                className={`sg-w-20 sg-h-20 md:sg-w-32 md:sg-h-32 xl:sg-w-40 xl:sg-h-40 sg-flex sg-justify-center sg-items-center sg-rounded-[4px] md:sg-rounded-[6px] ${
                  thicknessVal[selectedTool] === thicknessItem.thickness
                    ? 'sg-bg-sk-background-normal-alternative sg-text-sk-label-info sg-fill-sk-label-info'
                    : 'sg-bg-sk-white sg-hover:bg-sk-background-normal-alternative sg-text-sk-label-info sg-fill-sk-white'
                }`}
                onClick={() => onChangeThickness(thicknessItem.thickness)}
              >
                <div className='sg-flex sg-items-center sg-justify-center'>
                  <i className='sg-block md:sg-hidden'>{thicknessItem.smallIcon()}</i>
                  <i className='sg-hidden md:sg-block'>{thicknessItem.mediumIcon()}</i>
                </div>
              </button>
            ))}
          </div>

          {/* shape-fill */}
          <div
            className={`sg-flex sg-items-center sg-justify-center sg-px-[11px] xl:sg-px-12 sg-py-8 xl:sg-py-14 ${
              selectedTool === 'shape' ? 'sg-block' : 'sg-hidden'
            }`}
          >
            <button
              key='shape-paint'
              id='shape-paint'
              className={`sg-w-20 sg-h-20 md:sg-w-32 md:sg-h-32 sg-shrink-0 sg-flex sg-justify-center sg-items-center sg-rounded-md ${
                isShapeFilled
                  ? 'sg-border sg-bg-sk-background-normal-alternative'
                  : 'sg-bg-sk-white sg-hover:bg-sk-background-normal-alternative'
              }`}
              style={{ color: `${isShapeFilled ? colorVal[selectedTool] : '#878A93'}` }}
              onClick={() => onChangeShapeFilled()}
            >
              <i className='sg-block md:sg-hidden'>
                <PaintFillSmallIcon className='sg-shrink-0' />
              </i>
              <i className='sg-hidden md:sg-block'>
                <PaintFillMediumIcon className='sg-shrink-0' />
              </i>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
